import { Button } from '@/components/ui/button';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

type SocialButtonProps = {
  provider: 'google';
  onClick?: () => void;
  disabled?: boolean;
};

const SocialButton = forwardRef<HTMLButtonElement, SocialButtonProps>(
  ({ provider, onClick, disabled }, ref) => {
    const { t } = useTranslation('auth');
    return (
      <Button
        ref={ref}
        type="button"
        onClick={onClick}
        disabled={disabled}
        className="
          w-full h-11 rounded-full
          bg-transparent
          border-2 border-button-secondary
          text-button-secondary
          hover:bg-accent-100/10
          active:bg-accent-100/20
          focus-visible:ring-2 focus-visible:ring-accent-400
          disabled:opacity-60 disabled:cursor-not-allowed
        "
      >
        <span className="inline-flex items-center gap-3">
          <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden>
            <path
              d="M11 9V13.26H16.92C16.66 14.63 15.8799 15.7901 14.71 16.57L18.2799 19.3401C20.3599 17.4201 21.5599 14.6001 21.5599 11.2501C21.5599 10.4701 21.49 9.72005 21.3599 9.00012L11 9Z"
              fill="#5085FF"
            />
            <path
              d="M4.83514 13.0938L4.02998 13.7101L1.17993 15.9301C2.98993 19.52 6.69965 22.0001 10.9996 22.0001C13.9695 22.0001 16.4595 21.0201 18.2796 19.3401L14.7096 16.5701C13.7296 17.2301 12.4796 17.6301 10.9996 17.6301C8.13963 17.6301 5.70971 15.7001 4.83964 13.1001L4.83514 13.0938Z"
              fill="#3EB51E"
            />
            <path
              d="M1.17991 6.07007C0.429955 7.55001 0 9.22003 0 11C0 12.78 0.429955 14.45 1.17991 15.9299C1.17991 15.9399 4.83998 13.0899 4.83998 13.0899C4.61998 12.4299 4.48994 11.73 4.48994 10.9999C4.48994 10.2698 4.61998 9.56983 4.83998 8.90984L1.17991 6.07007Z"
              fill="#FFC800"
            />
            <path
              d="M10.9998 4.38C12.6199 4.38 14.0598 4.93998 15.2098 6.02L18.3598 2.87004C16.4498 1.09007 13.9699 0 10.9998 0C6.69988 0 2.98993 2.47 1.17993 6.07001L4.83988 8.91001C5.70983 6.30998 8.13986 4.38 10.9998 4.38Z"
              fill="#FF0000"
            />
          </svg>
          <span className="capitalize text-base">{t(`providers.${provider}`)}</span>
        </span>
      </Button>
    );
  },
);

export default SocialButton;
